import React, { HTMLProps, MouseEvent } from 'react';
import cls from 'classnames';
import Icon from '../Icon/Icon';
import type { IconName } from '../Icon/icon-names';
import Spinner from '../Spinner/Spinner';
import style from './Button.module.pcss';

export interface Props extends Omit<HTMLProps<HTMLButtonElement>, 'content'> {
  color: 'primary' | 'secondary';
  type?: 'submit' | 'button' | 'reset';
  variant?: 'button' | 'text' | 'mouseover' | 'dropdown' | 'list';
  iconLeft?: IconName;
  iconLeftClassName?: string;
  iconRight?: IconName;
  iconRightClassName?: string;
  content?: React.ReactNode;
  centerText?: boolean;
  isLoading?: boolean;
  onClick?(e?: MouseEvent);
  onMouseOver?(e?: MouseEvent): void;
  onMouseOut?(e?: MouseEvent): void;
}

const Button: React.FC<Props> = ({
  type = 'button',
  centerText = true,
  children,
  className,
  color,
  iconLeft,
  iconLeftClassName,
  iconRight,
  iconRightClassName,
  isLoading,
  variant = 'button',
  content,
  ...otherProps
}) => {
  return (
    <button
      {...otherProps}
      // @ts-ignore
      type={type}
      className={cls(
        color,
        variant,
        className,
        {
          [style.centerText]: centerText,
        },
        style.Button
      )}
    >
      <span className={style.content}>
        {isLoading ? (
          <Spinner
            baseColor={cls({
              grey500: color === 'primary',
              orange600: color === 'secondary',
            })}
            fillColor="white"
            size="16"
          />
        ) : (
          iconLeft && (
            <Icon icon={iconLeft} className={iconLeftClassName} size="16" />
          )
        )}

        <span className={style.buttonChild}>
          {content}
          {children}
        </span>

        {iconRight && (
          <Icon icon={iconRight} className={iconRightClassName} size="16" />
        )}
      </span>
    </button>
  );
};

export default Button;
